/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberExitDialogController', MemberExitDialogController);

    MemberExitDialogController.$inject = ['$scope', '$uibModalInstance', '$stateParams', '$http', 'DateUtils'];

    function MemberExitDialogController($scope, $uibModalInstance, $stateParams, $http, DateUtils) {
        var vm = this;

        vm.mode = $stateParams.mode;
        vm.membersArray = $stateParams.members;
        vm.members = [];
        vm.exitDate = new Date();
        vm.clear = clear;
        vm.processExits = processExits;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        $scope.options = {
            initDate: new Date()
        };

        loadAll();

        function loadAll() {
            $http.get('api/board/profiles/exit/process', {
                params: {
                    mode: vm.mode,
                    members: vm.membersArray
                }
            }).then(function(response) {
                vm.members = response.data;
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function processExits() {
            vm.isSaving = true;
            $http.put('api/board/profiles/exit/process', {}, {
                params: {
                    mode: vm.mode,
                    members: vm.membersArray,
                    exitDate: DateUtils.convertLocalDateToServer(vm.exitDate)
                }
            }).then(onSuccess, onError);
        }

        function onSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onError () {
            vm.isSaving = false;
        }


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
